import React, { useEffect, useRef, useState } from "react";
import { useLingui } from "@lingui/react";
import usFlag from "../assets/flag-us.svg";
import plFlag from "../assets/flag-pl.svg";
// Hebrew is disabled until RTL layout issues are addressed.
// import ilFlag from "../assets/flag-il.svg";
import "../App.css";

const LanguageSwitcher: React.FC = () => {
  const { i18n: linguiI18n } = useLingui();
  const [isOpen, setIsOpen] = useState(false);
  const switcherRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const closeMenu = (event: MouseEvent) => {
      if (!switcherRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", closeMenu);
    return () => document.removeEventListener("mousedown", closeMenu);
  }, []);

  const changeLanguage = (locale: string) => {
    linguiI18n.activate(locale);
    document.documentElement.setAttribute("lang", locale);
    // Future Hebrew support should restore locale-aware direction:
    // document.documentElement.setAttribute("dir", locale === "he" ? "rtl" : "ltr");
    document.documentElement.setAttribute("dir", "ltr");
    setIsOpen(false);
  };

  return (
    <div className="language-switcher" ref={switcherRef}>
      <button
        type="button"
        className="language-menu-button"
        onClick={() => setIsOpen((open) => !open)}
        aria-label="Select language"
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        <span className="material-symbols-outlined" aria-hidden="true">language</span>
      </button>

      {isOpen && (
        <div className="language-menu" role="menu">
          <button
            type="button"
            onClick={() => changeLanguage("en")}
            className={`language-button ${linguiI18n.locale === "en" ? "active" : ""}`}
            role="menuitemradio"
            aria-checked={linguiI18n.locale === "en"}
          >
            <img src={usFlag} width={16} height={12} alt="" aria-hidden="true" />
            English
          </button>

          <button
            type="button"
            onClick={() => changeLanguage("pl")}
            className={`language-button ${linguiI18n.locale === "pl" ? "active" : ""}`}
            role="menuitemradio"
            aria-checked={linguiI18n.locale === "pl"}
          >
            <img src={plFlag} width={16} height={12} alt="" aria-hidden="true" />
            Polski
          </button>
        </div>
      )}

      {/*
        Hebrew is disabled until RTL layout issues are addressed.
        <button
          onClick={() => changeLanguage("he")}
          className={`language-button ${linguiI18n.locale === "he" ? "active" : ""}`}
        >
          <img
            src={ilFlag}
            width={16}
            height={12}
            alt=""
            aria-hidden="true"
            style={{ display: "block" }}
          />
          Hebrew
        </button>
      */}
    </div>
  );
};

export default LanguageSwitcher;
